app.service("BrowseService", ['$rootScope', function ($rootScope) {

    const service = this;

    const siteHelper = $rootScope.site_helper;
    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const BrowseModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Browse",
        id: "browse",
        navigation_pointer: "browse_id",
        choice_is_breadcrumb: true,
        choice_order: ['overview', 'solution', 'component', 'site_range', 'range_info', 'edit']
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            overview: new RouteChoice({
                name: "Product Overview"
            }),
            solution: new RouteChoice({
                name: "Solution",
                breadcrumb_name: "Complete Solution",
                next_model_id: "room"
            }),
            component: new RouteChoice({
                name: "Component",
                next_model_id: "component"
            }),
            site_range: new RouteChoice({
                public_id: "range",
                name: "Range",
                next_model_id: "site_range"
            }),
            range_info: new RouteChoice({
                name: "Range Info",
                next_model_id: "range_info"
            }),
            edit: new RouteChoice({
                name: "Edit Cart"
            })
        },
        birth: function (values) {
            return new BrowseModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const choiceOrder = model.choice_order;

        const choices = siteHelper.cloneChoices(
            service.factory.choices
            , choiceOrder);


        for (let choiceID in choices) {
            const choice = choices[choiceID];
            choice.state_values.browseName = choice.name;
        }
        model.choice_order = choiceOrder;
        model.choices = choices;
    }

}]);